module.exports = __webpack_public_path__ + "montserrat-okta-light-webfont.70df5da69722ec23336c227bf131d5ab.ttf";